/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */
import {
  defaultPinDigit, defaultPinSegment, PHYSICAL_ORDER,
} from '../../blocks/customBlocks/display7SegmentsData';

// Ambos bloques de inicio usan la misma clave genérica `setupCode` y se pisan si
// conviven: quirk del legacy preservado.
export const COPA_initial_block = (block, generator) => {
  generator.definitions_.setupCode = '\n#include <SistemaInmunologico.h>\n';
  generator.setups_.setupCode = '\n  ConfiguracionInicial();\n';
  generator.setups_.setupCode += generator.statementToCode(block, 'Start');
  generator.setups_.setupCode += '\n  EvaluarVidasDeAgentesVirales();\n';
  return '\n';
};

export const COPA_codigo_initial_block = (block, generator) => {
  generator.definitions_.setupCode = '\n#include <CodigoSecreto.h>\n';
  generator.setups_.setupCode = '\n  ConfigInicial();\n';
  generator.setups_.setupCode += generator.statementToCode(block, 'Start');
  generator.setups_.setupCode += '\n  EvaluarCodigo();\n';
  return '\n';
};

export const COPA_nanobot_turn = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const direction = block.getFieldValue('NPIN1');
  return direction === '0'
    ? `\nGirarSentidoHorario(${angle});\n`
    : `\nGirarSentidoAntiHorario(${angle});\n`;
};

export const COPA_shoot_antigen = (block) => {
  const agent = block.getFieldValue('NPIN1');
  return `\nDispararAntigeno(${agent});\n`;
};

export const COPA_identify_agent = (block) => {
  const agent = block.getFieldValue('NPIN1');
  return `\nIdentificarAgenteViral(${agent});\n`;
};

export const COPA_evaluate_position = (block) => {
  const agent = block.getFieldValue('NPIN1');
  return `\nEvaluarPosicionAgenteViral(${agent});\n`;
};

export const COPA_shoot_special_antigen = (block, generator) => {
  const position = generator.valueToCode(block, 'NUM', generator.ORDER_NONE);
  const agent = block.getFieldValue('NPIN1');
  return `\nDispararAntigenoViralEspecial(${agent}, ${position});\n`;
};

export const math_number_minmax_copa_agent_position = (block, generator) => {
  const code = block.getFieldValue('SLIDER');
  return [code, generator.ORDER_ATOMIC];
};

// CargarNumero() pide orden físico a,b,c,d,e,f,g y pinSegment guarda a,f,b,g,e,c,d:
// de ahí PHYSICAL_ORDER. El firmware admite un solo dígito: si hay varios
// habilitados gana el último, como en el legacy.
export const display_7segments = (block) => {
  const { pinDigit, pinSegment } = block.getFieldValue('DISPLAY') || {};
  const digits = pinDigit || defaultPinDigit();
  const segments = pinSegment || defaultPinSegment();

  let pinDigito = 0;
  digits.forEach((d) => {
    if (d.state) pinDigito = d.pin;
  });

  const pins = PHYSICAL_ORDER.map((i) => segments[i].pin).join(', ');
  const states = PHYSICAL_ORDER.map((i) => (segments[i].state ? 1 : 0)).join(', ');

  return `
CargarNumero(
  ${pinDigito},
  ${pins},
  ${states}
);
`;
};
